/*
 * @Author: ylq
 * @Date: 2022-09-19 15:35:08
 * @Desc: DESC
 * @Last Modified by: ylq
 * @Last Modified time: 2023-05-30 11:29:49
 */
const DEFAULT_LAYOUT = () => import('@/layout/main-layout.vue');

const CALENDAR = {
  path: '/calendar',
  name: 'calendar',
  component: DEFAULT_LAYOUT,
  redirect: { name: 'calendar-layout' },
  meta: {
    title: '工作日程',
    requiresAuth: true,
    hideChildrenInMenu: true,
    icon: 'icon-calendar',
    roles: 'workSchedule',
    order: 9
  },
  children: [
    {
      path: '',
      name: 'calendar-layout',
      component: () => import('@/layout/pageTabs.vue'),
      redirect: { name: 'calendar-list' },
      meta: {
        requiresAuth: true,
        hideChildrenInMenu: true,
        hasTabs: true, // 页面是否是tabs展示
        tabsFixed: 49, // tabs 是否需要固定，如果没有这个属性，则不固定
        roles: 'workSchedule:view',
        title: '工作日程'
      },
      children: [
        {
          path: 'list',
          name: 'calendar-list',
          component: () => import('@/views/calendar/dashboard/dashboard.vue'),
          meta: {
            requiresAuth: true,
            roles: 'workSchedule:view',
            title: '日历看板'
          }
        },
        {
          path: 'schedule',
          name: 'calendar-schedule',
          component: () => import('@/views/calendar/schedule/schedule.vue'),
          meta: {
            requiresAuth: true,
            roles: 'workSchedule:view',
            title: '日程列表'
          }
        },
        {
          path: 'call',
          name: 'calendar-call',
          component: () => import('@/views/calendar/call-logs/call-logs.vue'),
          meta: {
            requiresAuth: true,
            roles: 'workSchedule:view',
            title: '通话列表'
          }
        }
      ]
    }
  ]
};

export default CALENDAR;
